// // --- src/components/Dashboard/KPICard.js ---
// Original simple version without 3D effect
// import React from 'react';
// const KPICard = ({ title, value, icon: Icon, trend, onClick }) => (
//   <div className="ui-card" onClick={onClick} style={{ padding: '24px', position: 'relative', cursor: onClick ? 'pointer' : 'default' }}>
//     <div className="flex-between">
//       <div>
//         <p className="kpi-label">{title}</p>
//         <h2 className="kpi-value">{value}</h2>
//         {trend && <span style={{ fontSize: '12px', color: '#28a745' }}>{trend}</span>}
//       </div>
//       <div style={{ background: 'rgba(0,0,0,0.05)', padding: '12px', borderRadius: '50%' }}>
//         <Icon size={24} color="var(--text-primary)" />
//       </div>
//     </div>
//   </div>
// );
// export default KPICard;

// --- src/components/Dashboard/KPICard.js ---
import React from 'react';

const KPICard = ({ title, value, icon: Icon, trend, onClick }) => (
  <>
    {/* ================= KPI CARD EFFECT STYLES (LOCAL ONLY) ================= */}
    <style>{`
      .kpi-card-3d {
        position: relative;
        overflow: hidden;
        transform-style: preserve-3d;
        perspective: 1000px;
        transition: transform 0.4s cubic-bezier(0.23, 1, 0.320, 1),
                    box-shadow 0.4s cubic-bezier(0.23, 1, 0.320, 1);
      }

      .kpi-card-3d:hover {
        transform: rotateY(6deg) rotateX(4deg) scale(1.03);
        box-shadow: 0 14px 28px rgba(0, 0, 0, 0.18);
      }

      /* Light sweep effect (no color change) */
      .kpi-card-3d::before,
      .kpi-card-3d::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(
          to right,
          transparent,
          rgba(255, 255, 255, 0.18),
          transparent
        );
        transform: translateX(-120%);
        transition: transform 0.6s cubic-bezier(0.23, 1, 0.320, 1);
        pointer-events: none;
      }

      .kpi-card-3d:hover::before {
        transform: translateX(120%);
      }

      .kpi-card-3d::after {
        background: linear-gradient(
          to left,
          transparent,
          rgba(255, 255, 255, 0.12),
          transparent
        );
      }

      /* Disable hover effects on touch devices */
      @media (hover: none) {
        .kpi-card-3d:hover {
          transform: none;
          box-shadow: none;
        }
        .kpi-card-3d::before,
        .kpi-card-3d::after {
          display: none;
        }
      }
    `}</style>

    {/* ================= KPI CARD UI ================= */}
    <div
      className="ui-card kpi-card-3d"
      onClick={onClick}
      style={{
        padding: '24px',
        cursor: onClick ? 'pointer' : 'default'
      }}
    >
      <div className="flex-between">
        <div>
          <p className="kpi-label">{title}</p>
          <h2 className="kpi-value">{value}</h2>
          {trend && (
            <span style={{ fontSize: '12px', color: '#28a745' }}>
              {trend}
            </span>
          )}
        </div>

        <div
          style={{
            background: 'rgba(0,0,0,0.05)',
            padding: '12px',
            borderRadius: '50%'
          }}
        >
          <Icon size={24} color="var(--text-primary)" />
        </div>
      </div>
    </div>
  </>
);

export default KPICard;